<div class="row table-body" id="container-industry-distribution">
  <div class="col-12 mt-3" *ngIf="industryDistribution?.length; else noData">
    <div class="row table-row table-heading">
      <div class="col-12 tt-buy-hgt">
        <label class="title-fee">%  {{'Giá trị tài sản' | translate}} (GAV)</label>
        <br />
      </div>
    </div>
    <div class="row row-color" *ngFor="let item of industryDistribution">
      <div class="col-5 col-sm-5 col-lg-5 tt-buy-hgt no-padding-right">
        <label> {{item.industry}} </label>
      </div>
      <div class="col-7 col-sm-7 col-lg-7 tt-buy-hgt">
        <div class="d-flex flex-column">
          <div class="d-flex align-items-center">
            <div class="bar mr-2" [style.width]="item.width"></div>
            <span>{{item.assetPercent}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3 " *ngIf="updateTime">
    <div class="d-flex">
      <div class="isDesktop mr-1"></div>
      <div class="isMobile mr-3"></div>
      <span>{{'Theo báo cáo tháng' | translate}} {{updateTime}}</span>
    </div>
  </div>
</div>
<ng-template #noData>
  <div class="block-nodata flex-center">
    <img [src]="'icon/nodata-chart.svg' | image" alt="không dữ liệu chart" />
    <h5>{{'Không có dữ liệu' | translate}}</h5>
  </div>
</ng-template>